const state = {
  type: null,
  message: null,
  persist: false,
};

const actions = {
  success({ commit }, payload) {
    commit('success', payload);
  },
  error({ commit }, payload) {
    commit('error', payload);
  },
  warning({ commit }, payload) {
    commit('warning', payload);
  },
  clear({ commit }) {
    commit('clear');
  }
};

const mutations = {
  success(state, payload) {
    state.type = 'alert-success';
    state.message = payload.message;
    state.persist = payload.persist || false
  },
  error(state, payload) {
    state.type = 'alert-danger';
    state.message = payload.message;
    state.persist = payload.persist || false
  },
  warning(state, payload) {
    state.type = 'alert-warning';
    state.message = payload.message;
    state.persist = payload.persist || false
  },
  clear(state) {
    state.type = null;
    state.message = null;
    state.persist = false;
  }
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
};
